import cleanGraphQLResponse from '~~/utils/clean-graphql';

export async function useMainCategories(): Promise<any[]> {
    const {
        data: categoriesData,
    } = await useAsyncGql({operation: 'findMainCategories'});

    return <any>cleanGraphQLResponse(categoriesData.value).categories;
}
